import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
// import { IdResponse } from '../../models/idResponse';
import { jobLog } from '../../models/joblog';
import { ReturnObject } from '../../models/returnObject';
import { SetAdminItem } from '../../models/setadminitem';
import { Week } from '../../models/week';
import { APIService } from '../api.service';
import { NewEmplyeeItem } from '../../models/newemployeeitem';

@Injectable()
export class SysadminService {

  constructor(private api: APIService) { }

  getEmps(): Observable<ReturnObject<SetAdminItem[]>> {
    return this.api.getAPI(`sysadmin/getemps`);
  }

  getErrors(): Observable<ReturnObject<jobLog[]>> {
    return this.api.getAPI('sysadmin/batcherrors');
  }  

  changeAdminStatus(emp: SetAdminItem): Observable<ReturnObject<string>> {
    return this.api.postAPI('sysadmin/changeadminstatus', emp);
  }

  changeReportingStatus(emp: SetAdminItem): Observable<ReturnObject<string>> {
    return this.api.postAPI('sysadmin/changereportingstatus', emp);
  }
}

